// Compose modal state lives in a context so any component can open it
// (topbar "+" button, empty-state CTAs on the profile page, etc.) without
// prop-drilling. The <ComposeModal /> component itself reads this context
// to decide whether to render.

import {
    createContext, useCallback, useContext, useMemo, useState,
    type PropsWithChildren,
} from 'react';

interface ComposeCtx {
    open: boolean;
    openCompose:  () => void;
    closeCompose: () => void;
}

const Ctx = createContext<ComposeCtx | null>(null);

export function ComposeProvider({ children }: PropsWithChildren) {
    const [open, setOpen] = useState(false);
    const openCompose  = useCallback(() => setOpen(true),  []);
    const closeCompose = useCallback(() => setOpen(false), []);
    const value = useMemo(() => ({ open, openCompose, closeCompose }), [open, openCompose, closeCompose]);
    return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useCompose(): ComposeCtx {
    const v = useContext(Ctx);
    if (!v) throw new Error('useCompose must be inside <ComposeProvider>');
    return v;
}
